export default function Terms() {
  return (
    <main className="container">
      <h1>Terms & Conditions</h1>

      <p>
        By using JobLink and submitting an application, you agree to the
        following terms and conditions.
      </p>

      <h2>1. Service Description</h2>
      <p>
        JobLink provides CV creation or updates, job search assistance, and
        interview preparation. We do not guarantee job placement or employment.
      </p>

      <h2>2. CV & Application Submission</h2>
      <p>
        Applicants must submit accurate information. Applicants without a CV
        will have one created for them. JobLink is not responsible for false or
        misleading information provided by applicants.
      </p>

      <h2>3. Payment</h2>
      <p>
        A non-refundable service fee of <strong>₦10,000</strong> is required.
        Services begin only after payment confirmation and proof submission.
      </p>

      <h2>4. Interview Slots</h2>
      <p>
        Each applicant is entitled to a maximum of <strong>three (3)</strong>{" "}
        interview opportunities. After this, a new application and payment are
        required.
      </p>

      <h2>5. Proof Submission</h2>
      <p>
        Applicants must submit proof of payment and their CV using the link sent
        in the auto-response email. Failure to do so may delay or cancel service.
      </p>

      <h2>6. Interview Training</h2>
      <p>
        JobLink provides interview preparation only. Interview performance and
        outcomes remain the applicant’s responsibility.
      </p>

      <h2>7. No Guarantee</h2>
      <p>
        JobLink does not guarantee job offers, interview success, or employment.
      </p>

      <h2>8. Confidentiality</h2>
      <p>
        Applicant information and documents are kept confidential and used only
        for job application and career support purposes.
      </p>

      <h2>9. Refund Policy</h2>
      <p>All payments are non-refundable once services have started.</p>

      <h2>10. Changes to Terms</h2>
      <p>
        JobLink reserves the right to update these terms at any time. Continued
        use of the platform means acceptance of updated terms.
      </p>
    </main>
  );
}